import type { TimelineAction } from '../../types';
import styles from './ActionCard.module.css';

interface Props {
  action: TimelineAction;
}

export default function TimelineCard({ action }: Props) {
  return (
    <div className={styles.card}>
      {action.title && <div className={styles.cardTitle}>{action.title}</div>}
      {action.events.map((event, idx) => (
        <div key={idx} className={styles.timelineItem}>
          <div className={styles.timelineDate}>{event.date}</div>
          <div className={styles.timelineDescription}>{event.description}</div>
          <div className={styles.timelineCategory}>{event.category}</div>
        </div>
      ))}
    </div>
  );
}
